import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuvyrgpack: FaireProductEntity = {
  token: "p_kuvyrgpack",
  type: "product",
  name: "Tomato Mini Candle / Latina + Midwest Garden Inspired",
  brandToken: "b_wp6dvttf8e",
  brandName: "Fresa Creative",
  imageUrl:
    "https://cdn.faire.com/fastly/5393d82e1f6ff149ae3c6908530e7d11f582066ab668b4f2678a904a7bfcace9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c034cd3bcea02900357dc573e375402da480f4cd62d3069f2c96ce0e59c10370.jpeg",
    "https://cdn.faire.com/fastly/363bb9bf13c59f9771632c79eb01336da12badb518646d7a2cea7986128fa8e5.png",
    "https://cdn.faire.com/fastly/21e65c356ff484f4e63b9de152b81a07535c6c9f11a352c04d8e642d0ba0fc0b.jpeg",
  ],
  priceDollars: 8,
  description:
    "For when you just can't seem to keep a tomato plant alive, but want to live that Barefoot Contessa fantasy of growing what you eat.\n\nBut actually: a true to scent tomato garden, earthy and plentiful, with almost spicy notes of arugula, lemon zest and thyme\n",
  tags: [],
  msrpDollars: 16,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:55.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
